import { Badge } from '@mantine/core';
import IconButton from '@ui/components/IconButton/IconButton';
import Text from '@ui/components/Text/Text';

type EmailChipProps = {
	email: string;
	isValid: boolean;
	onDeleteClick: ( email: string ) => void;
};

const BADGE_STYLES = {
	root: {
		padding: '4px 6px',
		height: '30px'
	}
};

const EmailChip = ( { email, isValid, onDeleteClick }: EmailChipProps ) => (
	<Badge
		styles={BADGE_STYLES}
		color={isValid ? 'primary' : 'red'}
		radius="4px"
		maw="100%"
		rightSection={(
			<IconButton
				key={`${email}-${isValid}`}
				color={isValid ? 'primary' : 'red'}
				size="14px"
				icon="close"
				onClick={() => onDeleteClick( email )}
			/>
		)}
	>
		<Text truncate="end" maw="100%" variant="footnote">{email}</Text>
	</Badge>
);

export default EmailChip;
